// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandler,
    createHandlerChainRunner,
    Handler,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import loadOpenBids from "@steiner/App/Handlers/XNG/LoadOpenBids";
import { getOpenBids, OpenBidsApiParameter, OpenBidsModel } from "@steiner/App/Services/OpenBidsService";
import { CustomAppState } from "@steiner/App/Store/Reducers";

type HandlerType = Handler<HasOnSuccess, OpenBidsModel>;

export const defaultParameters = {
    customerSequence: "-1",
    orderNumber: "",
    releaseNumber: "",
    poNumber: "",
    page: 1,
    pageSize: 8,
    fromDate: "",
    toDate: "",
};

export const DispatchClearOpenBidsSearchParams: HandlerType = props => {
    props.dispatch({ type: "xOpenBids/ClearSearchParams" } as any);
};

export const DispatchCompleteLoadOpenBids: HandlerType = props => {
    const pagination = (props.getState() as CustomAppState).xOpenBids.pagination;
    props.dispatch(
        loadOpenBids({
            ...defaultParameters,
            pageSize: pagination ? pagination.pageSize : 16,
            page: pagination ? pagination.page : 1,
        }),
    );
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [DispatchClearOpenBidsSearchParams, DispatchCompleteLoadOpenBids, ExecuteOnSuccessCallback];

const clearOpenBidsSearchParams = createHandlerChainRunner(chain, "ClearOpenBidsSearchParams");

export default clearOpenBidsSearchParams;
